<template>
<div>
  <template v-if="!authorized">
    <btn v-if="lang==='RU'" title="Идентификатор можно получить у менеджера" color="primary" class="btn-sm btn-call waves-effect" @click.native="showModal = true" > <i class="fa fa-user-plus" aria-hidden="true">  </i> Вход </btn>
    <btn v-if="lang==='EN'" title="ID can be obtained from the manager" color="primary" class="btn-sm btn-call waves-effect" @click.native="showModal = true" > <i class="fa fa-user-plus" aria-hidden="true">  </i> Login </btn>
    <btn v-if="lang==='GE'" title="პირადობის მოწმობა შეიძლება იყოს მენეჯერისგან" color="primary" class="btn-sm btn-call waves-effect" @click.native="showModal = true" > <i class="fa fa-user-plus" aria-hidden="true">  </i> შესვლა </btn>
    <modal v-if="showModal" @close="showModal = false" cascade class="text-left">
      <modal-header class="primary-color white-text">
        <h4 v-if="lang==='RU'" class="title"><fa class="fa fa-lock" /> Введите идентификатор</h4>
        <h4 v-if="lang==='EN'" class="title"><fa class="fa fa-lock" /> Enter ID</h4>
        <h4 v-if="lang==='GE'" class="title"><fa class="fa fa-lock" /> შეიყვანეთ ID</h4>
      </modal-header>
      <modal-body class="grey-text">
        <input class="form-control form-control-lg" type="text" v-model="UID" label="UID" placeholder="00000000-0000-0000-0000-0000000000000" icon="user" validate error="wrong" success="right"/>
       </modal-body>
      <modal-footer>
        <div>
        <btn color="primary" title="Войти" class="btn-sm btn-call" data-dismiss="modal" @click.native="$emit('auth', UID)" authcolor="success"> <i class="fas fa-user-plus"> </i> Войти </btn>
        </div>
      </modal-footer>
    </modal>
  </template>
  <template v-if="authorized && !mng">
    <btn class="btn-sm btn-call" title="Выход" outline="info" @click.native="logoff()"><i class="fas fa-sign-out-alt"></i></btn>
</template>
<template v-if="mng">
    <btn class="btn-sm btn-call" title="Менеджер" outline="danger" @click.native="logoff()"><i class="fas fa-sign-out-alt"></i></btn>
</template>
</div>
</template>

<script>
import { Container, Row, Column, MdTextarea, Btn, Fa, Modal, ModalHeader, ModalBody, ModalFooter, Tooltip } from 'mdbvue'
export default {
  name: 'Login',
  components: {
    Container,
    Row,
    Column,
    MdTextarea,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Tooltip
  },
  props: ['authorized', 'mng', 'lang'],
  methods:
    {
      logoff: function () {
        this.$localStorage.remove('UID')
        this.$localStorage.remove('Description')
        this.$localStorage.remove('MNG')
        this.$localStorage.remove('DescriptionMNG')
        this.$emit('logoff')
        this.UID = ''
        // location.reload()
      }
    },
  mounted () {
  },
  data () {
    return {
      showModal: false,
      UID: ''
    }
  }
}
</script>

<style scoped>
 .btn-call {
  border-radius: 1.5rem;
  padding: 1rem;
  padding-top: 0.9rem;
  padding-right: 1.1rem;
  padding-bottom: 0.9rem;
  padding-left: 1,1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue